export default __webpack_public_path__ + "static/media/RB.854c112c.jpg";